module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.9ff12f69.ttf";